import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import AuthPage from "./components/auth/AuthPage";
import RoleSelector from "./components/auth/RoleSelector";
import Dashboard from "./components/Dashboard";
import BorrowerStatusPage from "./components/shared/BorrowerStatusPage";
import PFSPublicForm from "./components/shared/PFSPublicForm";
import DebtSchedulePublicForm from "./components/shared/DebtSchedulePublicForm";
import BalanceSheetPublicForm from "./components/shared/BalanceSheetPublicForm";
import UseOfFundsPublicForm from "./components/shared/UseOfFundsPublicForm";
import IntakePublicForm from "./components/shared/IntakePublicForm";
import MerchantPreAppPublicForm from "./components/shared/MerchantPreAppPublicForm";
import MerchantIntakePublicForm from "./components/shared/MerchantIntakePublicForm";
import JumboOwnerInfoPublicForm from "./components/shared/JumboOwnerInfoPublicForm";
import JumboOwnerSignPublicForm from "./components/shared/JumboOwnerSignPublicForm";
import SharedUnderwritingView from "./components/shared/SharedUnderwritingView";
import BorrowerApplicationView from "./components/shared/BorrowerApplicationView";
import ImpersonationBanner from "./components/admin/ImpersonationBanner";
import { Toaster } from "./components/ui/sonner";

const AppContent = () => {
  const { 
    user, 
    loading, 
    login, 
    register, 
    switchRole,
    isAuthenticated, 
    needsRoleSelection 
  } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-slate-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AuthPage onLogin={login} onRegister={register} />;
  }

  if (needsRoleSelection) {
    return <RoleSelector user={user} onRoleSelect={switchRole} />;
  }

  return (
    <>
      <ImpersonationBanner />
      <Dashboard />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/borrower/:token" element={<BorrowerStatusPage />} />
        <Route path="/pfs/:token" element={<PFSPublicForm />} />
        <Route path="/debt-schedule/:token" element={<DebtSchedulePublicForm />} />
        <Route path="/balance-sheet/:token" element={<BalanceSheetPublicForm />} />
        <Route path="/use-of-funds/:token" element={<UseOfFundsPublicForm />} />
        <Route path="/intake/:productType/:token" element={<IntakePublicForm />} />
        <Route path="/merchant-pre-app/:token" element={<MerchantPreAppPublicForm />} />
        <Route path="/mp-intake/:token" element={<MerchantIntakePublicForm />} />
        <Route path="/jumbo-owner-info/:token" element={<JumboOwnerInfoPublicForm />} />
        <Route path="/jumbo-owner-sign/:token" element={<JumboOwnerSignPublicForm />} />
        <Route path="/shared/underwriting/:token" element={<SharedUnderwritingView />} />
        <Route path="/shared/borrower/:token" element={<BorrowerApplicationView />} />
        <Route path="*" element={
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
